import React, { useState, useEffect } from "react";
import { Col, Container, Modal, Row, Button, Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'
import moment from "moment/moment";
import { useDispatch, useSelector } from "react-redux";
import APICom from "../../../utils/helpers/APICom";
import TimePicker from "rc-time-picker";
import GridControl from "../../Controls/gridControl";
import { ValidateModule } from "tabulator-tables";


function IsGridDataExists(props)
{
    try {
       let lengthOfGridData =  props?.GridRowData?.length;
       if(lengthOfGridData > 0)
       {
            return lengthOfGridData;
       }
       else
       {
        return 0;
       }
    } catch (error) {
        return 0;
    }
}

function AgentNotesDialog(props){

    const { ASCSSettingData }  = useSelector((store) => store.combinedata);
    const [ClientInformation, setClientInformation] = useState(null); 
    const [AddNotes, setAddNotes] = useState('');
    const { loginData }  = useSelector((store) => store.login);
    const [AgentNotesData, setAgentNotesData] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const { GlobalASCSData, DispatchVehicleData, FundingSourceData } = useSelector((store) => store.combinedata);
    const [isChecked, setChecked] = useState(false);

    const SPACES = "\u00A0\u00A0";
    const TITLE = "Agent Notes";
    const DELETE_BUTTON = "Delete";
    const SAVE_BUTTON = "Save";
    const CLOSE_BUTTON = "Close";

    let ConfirmationNumber = IsGridDataExists(props) > 0 ? props.GridRowData[0]["ConfirmationNo"] : "";
    let RequestAffiliateId = IsGridDataExists(props) > 0 ? props.GridRowData[0]["RequestAffiliateID"] : "";
    let ClientID = IsGridDataExists(props) > 0 ? props.GridRowData[0]["ClientID"] : "";


    useEffect(()=> {

        FetchAgentNotes(); //Get Notes data
        FetchClientInformation() //Get Rider information


    }, []);

    const FetchAgentNotes = async () => {
        let params ={

            "iRefID": ConfirmationNumber,
            "iATSPID": RequestAffiliateId,
            "iClientID": ClientID
        }
        let response = await APICom.fetchData("", "TripActions/GetAgentNotesInformation", "post", { "Content-Type": "application/json" }, params, null);
        if(response.data.message === "Success"){
            setAgentNotesData(response.data.data);
        }
        else if(response.data.message === "No data found"){
            setAgentNotesData([])

        }
    }

    const FetchClientInformation = async () => {
        let params ={
            "iClientID": ClientID
        }
        let response = await APICom.fetchData("", "TripActions/GetAgentClientInformation", "post", { "Content-Type": "application/json" }, params, null);
        if(response.data.message === "Success"){
            setClientInformation(response.data.data);
        }
        else if(response.data.message === "No data found"){
            setClientInformation("");

        }
    }
    
    const handleCloseAgentNotesDialog = () => {
        if (props.showAgentNotesDialog) {
            props.setAgentNotesDialog(false);
        }
    }

    const vFirstName = ClientInformation?.vFirstName || '';
    const vLastName = ClientInformation?.vLastName || '';
    let vName = vFirstName + vLastName;
    vName = vName === ""? "N/A":vName;
    const vMedicalId = ClientInformation?.vMedicalId || 'N/A';
    const bIsActive = ClientInformation?.bIsActive || '';
    const vEmergency_firstname = ClientInformation?.vEmergency_firstname || '';
    const vEmergency_lastname = ClientInformation?.vEmergency_lastname || '';
    let emg_name = vEmergency_firstname+vEmergency_lastname
    emg_name = emg_name === ""? "N/A":emg_name;
    const vRemarks = ClientInformation?.vRemarks || 'N/A';
    const vHomePhone = ClientInformation?.vHomePhone || '';
    const iAmbulatoryCount = ClientInformation?.iAmbulatoryCount || '0';
    const iAmbulatoryPCACount = ClientInformation?.iAmbulatoryPCACount || '0';
    const vEmergency_PhoneNo = ClientInformation?.vEmergency_PhoneNo || '';
    const vAddress1 = ClientInformation?.vAddress1 || '';
    const vAddress2 = ClientInformation?.vAddress2 || '';
    const vState = ClientInformation?.vState || '';
    const vZip = ClientInformation?.vZip || '';
    const vAddress = vAddress1 +" "+ vAddress2 +" "+ vState +" "+ vZip;

    const vCellPhone = ClientInformation?.vCellPhone || '';
    const iWheelChairCount = ClientInformation?.iWheelChairCount || '0';
    const iWheelChairPCACount = ClientInformation?.iWheelChairPCACount || '0';
    const iID = ClientInformation?.iID || '';

    const handleCancelAgentNotesDialog = async() => {
        if (props.showAgentNotesDialog) {
            props.setAgentNotesDialog(false);
        }
    }

    const handleSaveAgentNotes = async() => {
        let params ={
            "iRefID": ConfirmationNumber,
            "iATSPID": String(RequestAffiliateId),
            "iClientID": String(ClientID),
            "vNotes": AddNotes,
            "iAppID": "5",
            "iUserID": String(loginData.iUserID),
            "vUserName" : loginData.vDisplayName,
            "isAppliedToProfile" : isChecked
            
        }
        let response = await APICom.fetchData("", "TripActions/SaveNotesForTrip", "post", { "Content-Type": "application/json" }, params, null);
        if(response.data === "Success"){
            // console.log("Saved");
            setAddNotes("");
            FetchAgentNotes();
        }
        else if(response.data === "Fail"){
            console.log("Data Saving Failed");

        }
        
    }

    const handleCheckboxChange = () => {
        const newValue = !isChecked;
        setChecked(newValue);
      };

    function changeAddNotes(){
        console.log("changed notes");
    }

    const addNotes = {
        width: '520px',
        height: '70px',
        resize: 'none',
        overflowY: 'auto',
      };

      const savedNotes = {
        width: '630px',
        height: '70px',
        resize: 'none',
        overflowY: 'auto',
        backgroundColor: 'lightgray'
      }

    const forClient =  {
        width: "150px",
        textAlign: "left",
        padding: "5px"
    }

    const forClientLable =  {
        width: "120px",
        textAlign: "left",
        padding: "5px"
    }


      const [AgentNotesGridOptions, setAgentNotesGridOptions] = useState({
        height: 300,
        heightoffset: 600,
        calculateHeight: false,
        pagination: true,
        paginationMode: "local",
        paginationSize: [5, 10, 15],
        selectable: true,
        reactiveData:false, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName:"AgentNotesGrid",
        paginationCounter:"rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        vDefaultGridName: "AgentNotesGrid",
        index: "iID",
        autoColumns: true,
        sortCondition: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        AlwaysHiddenColumns:["iID", "TripAgentInstructions", "iUserID", "iAppID", "iATSPID"],
        containerClass: "col position-relative mt-2",
        Containerstyle: {},
        customWidthCols: ["Agent Notes-665"],
        footerElement: '',
        ActionList: true,
        tableDoubleClickFunc: function(table, row) {
        },
        footerElementHandles: function (table) {},
        rowSelectionChangeHandle: function(data){

        },
    });
    
    const handleAgentNotesGrid = () => {
        console.log("reload");
    };

    const DeleteAgentNotes = async  (id) => {

        let params ={
            "iID": parseInt(id),
        }
        let response = await APICom.fetchData("", "TripActions/DeleteAgentNotesById", "post", { "Content-Type": "application/json" }, params, null);
        if(response.data === "Success"){
            FetchAgentNotes();
            console.log("Notes Deleted");
        }
        else if(response.data === "Fail"){
            console.log("Data Saving Failed");

        }

        
    }

    


    return (
        <>
            <Modal show={props.showAgentNotesDialog ? 1 : 0} centered onHide={handleCloseAgentNotesDialog} backdrop="static" keyboard={true}  size="lg" animation={true}
                aria-labelledby="contained-modal-title-vcenter" dialogClassName="modal-tripDetails-width">
                <Modal.Header className='activate_dialog_header_bgcolor tripDetails-DialogHeader user-select-none' closeButton>
                    <Modal.Title>{ TITLE }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row className="w-100 m-0">
                    <Col>
                        
                        <Row className="border">
                            <Col>
                                <p className="m-0 user-select-none fw-bold">Name:</p>
                                <p className="m-0 user-select-none fw-bold mt-1">Medical ID:</p>
                                <p className="m-0 user-select-none fw-bold mt-1">Client ID:</p>
                                <p className="m-0 user-select-none fw-bold mt-1">Conf. Number:</p>
                            </Col>
                            <Col>
                                <p className="m-0 user-select-none">{vName}</p>
                                <p className="m-0 user-select-none text-nowrap mt-1">{vMedicalId}</p>
                                <p className="m-0 user-select-none text-nowrap mt-1">{iID}</p>
                                <p className="m-0 user-select-none text-nowrap mt-1">{ConfirmationNumber}</p>
                            </Col>
                            <Col>
                                <p className="m-0 user-select-none fw-bold">Remarks:</p>
                                <p className="m-0 user-select-none fw-bold mt-1">Active:</p>
                                <p className="m-0 user-select-none fw-bold mt-1">Address:</p>
                            </Col>
                            <Col>
                                <p className="m-0 user-select-none text-nowrap">{vRemarks}</p>
                                <p className="m-0 user-select-none text-nowrap mt-1">{bIsActive ? 'True' : 'False'}</p>
                                <p className="m-0 user-select-none mt-1" style={{fontSize:"small"}}>{vAddress}</p>
                            </Col>
                        </Row>
                        
                        
                        <Row className="border mt-1">
                            <Col>
                                <p className="m-0 user-select-none fw-bold">Emg Contact:</p>
                                <p className="m-0 user-select-none fw-bold mt-1">Home Phone:</p>
                            </Col>
                            <Col>
                                <p className="m-0 user-select-none">{emg_name}</p>
                                <p className="m-0 user-select-none mt-1">{vHomePhone}</p>
                            </Col>
                            <Col>
                                <p className="m-0 user-select-none fw-bold">Emg Number:</p>
                                <p className="m-0 user-select-none fw-bold mt-1">Cell-Phone:</p>
                            </Col>
                            <Col>
                                <p className="m-0 user-select-none text-nowrap">{vEmergency_PhoneNo}</p>
                                <p className="m-0 user-select-none text-nowrap mt-1">{vCellPhone}</p>
                            </Col>
                            
                        </Row>
                        
                        <Row className="border mt-1">
                            <Col>
                                <p className="m-0 user-select-none fw-bold">AMB Count:</p>
                                <p className="m-0 user-select-none fw-bold mt-1">WC Count:</p>
                                
                            </Col>
                            <Col>
                                <p className="m-0 user-select-none">{iAmbulatoryCount}</p>
                                <p className="m-0 user-select-none mt-1">{iWheelChairCount}</p>

                            </Col>
                            <Col>
                                <p className="m-0 user-select-none fw-bold ">PCA WC:</p>
                                <p className="m-0 user-select-none fw-bold mt-1">AMB PCA:</p>
                            </Col>
                            <Col>
                                <p className="m-0 user-select-none">{iWheelChairPCACount}</p>
                                <p className="m-0 user-select-none mt-1">{iAmbulatoryPCACount}</p>
                            </Col>
                                
                        </Row>
                    </Col>
                </Row>
                <Row className="border mt-1 m-0">
                    <Col>
                        <Row>
                            <Col xs={3}>
                                <p className="m-0 user-select-none fw-bold ">Add Notes:</p>
                            </Col>
                            <Col xs={9}>
                                <textarea
                                    name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                                    rows={2}
                                    cols={10}
                                    id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                                    className="tripDetails-label-dataFields float-start w-100 m-1"
                                    style={addNotes}
                                    value={AddNotes}
                                    onChange={(e) => setAddNotes(e.target.value)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <label className="form-check-label fw-bold user-select-none" htmlFor="exampleCheck">
                                    Apply to Profile:
                                </label>
                                <input
                                    type="checkbox"
                                    className="form-check-input mx-3 border-dark"
                                    id="exampleCheck"
                                    style={{cursor:"pointer"}}
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                />
                            </Col>
                            <Col className="px-1 p-0">
                                <Button className="float-end m-1" variant="secondary" onClick={handleCancelAgentNotesDialog} >
                                    {CLOSE_BUTTON}
                                </Button>
                                <Button className="float-end mx-2 m-1" variant="dark" onClick={handleSaveAgentNotes}>
                                    {SAVE_BUTTON}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className="mt-1 m-0">
                    {AgentNotesData && AgentNotesData.length > 0 && (
                        <GridControl ShowLoader={showLoader} ReloadDataFunction={handleAgentNotesGrid} Data={AgentNotesData}
                        options={AgentNotesGridOptions} DeleteAgentNotes={DeleteAgentNotes}/>
                    )}
                </Row>

                
                </Modal.Body>


            </Modal>   
        </>
    )
}

export default AgentNotesDialog;